import React from 'react';
import { Dispatch } from 'architecture'
import _ from 'lodash'
import DatePicker from 'react-datepicker';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faTags } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons'
import { faSave } from '@fortawesome/free-solid-svg-icons'
//import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify'
import DropZone from 'react-dropzone'
import moment from 'moment'

import TagInput from './TagInput/TagInput'
import Auth from './Auth'

import loading from '../media/loading.svg'
import logo from '../media/logo.svg'
import Tag from './TagInput/Tag'

export default (props) => {
  // const tagId = props.TagEditor && props.TagEditor.selected ? props.TagEditor.selected : null
  // const tag = props.Tags && tagId ? props.Tags[tagId] : {name: '', color: '', type: '', children: ''}
  const tag = props.TagEditor ? props.TagEditor : {name: '', color: '', type: '', children: ''}
  const saveButton = props.TagEditor && props.TagEditor.edited ? ' near-white ' : ' gray '
      //For mobile style={{minWidth: '90%'}}>
  return (
      <div className='mw5 w-100 bl b--moon-gray overflow-y-scroll bg-dark-gray pb3' style={{WebkitOverflowScrolling: 'touch'}}>
        <div className='pt3 w-100 near-white flex flex-column' style={{alignItems: 'flex-start'}}>
          <div className='ph3 w-100 flex justify-between'>
            <div className='b--moon-gray f4'>Tag Editor</div>
            <div 
              className='relative pointer' 
              onClick={e => Dispatch.nextAction('TagEditor', 'close')}
              style={{top:2}}>
              <FontAwesomeIcon icon={faTimes}/>
            </div>
          </div>
          <div className='w-100 ph3 pt3 flex flex-column'>
            <div className='f5 fw7'>Name</div>
            <input 
                className={'mt1 input-reset pv1 br2 pl2 w-100 bn bg-black white f5'}
                value={tag.name}
                style={{outline: 'none'}}
                type='text'
                onChange={e => Dispatch.nextAction('TagEditor', 'update', {type: 'name', value: e.target.value})}
            />
            <div className='mt2 f5 fw7'>Color</div>
            <input 
                className={'mt1 w-100 input-reset pv1 br2 pl2 w-100 bn bg-black white f5'}
                value={tag.color}
                style={{outline: 'none'}}
                type='text'
                onChange={e => Dispatch.nextAction('TagEditor', 'update', {type: 'color', value: e.target.value})}
            />
            <div className='mt2 f5 fw7'>Type</div>
            <input 
                className={'mt1 w-100 input-reset pv1 br2 pl2 w-100 bn bg-black white f5'}
                value={tag.type}
                style={{outline: 'none'}}
                type='text'
                onChange={e => Dispatch.nextAction('TagEditor', 'update', {type: 'type', value: e.target.value})}
            />
            <div className='mt2 f5 fw7'>Children</div>
            <input 
                className={'mt1 w-100 input-reset pv1 br2 pl2 w-100 bn bg-black white f5'}
                value={tag.children}
                style={{outline: 'none'}}
                type='text'
                onChange={e => Dispatch.nextAction('TagEditor', 'update', {type: 'children', value: e.target.value})}
            />
          </div>
          <div className={'ph3 w-100 mt4 flex justify-between' + saveButton } >
            <div>
              { props.TagEditor && props.TagEditor.id ?
                <div 
                  className='relative pl1 f5 red underline pointer' 
                  style={{top:5}}
                  onClick={e => Dispatch.nextAction('TagEditor', 'delete')}>
                  delete
                </div>
                :
                null
              }
            </div>
            <div 
              className='f3 pointer' 
              onClick={e => Dispatch.nextAction('TagEditor', 'save')}>
              <FontAwesomeIcon icon={faCheckCircle}/>
              </div>
          </div>
        </div>
      </div>
  )
}